import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import designReducer from 'src/store/design/designSlice';
import sessionReducer from 'src/store/session/sessionSlice';
import webviewReducer from 'src/store/webview/webviewSlice';
import statusReducer from 'src/store/status/statusSlice';
import loaderReducer from 'src/store/loader/loaderSlice';

export const store = configureStore({
    reducer: {
        design: designReducer,
        session: sessionReducer,
        webview: webviewReducer,
        status: statusReducer,
        loading: loaderReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
